import React from 'react';
import './Videoheader.css';

const Videoheader = ({ content = {} }) => {
  return (
    <section
      className="video-production"
      style={{ backgroundImage: `url(${process.env.PUBLIC_URL}${content.heroImage || '/video-prod.webp'})` }}
    >
      <div className="overlay"></div>
      <div className="content">
        <h1>{content.title || 'Video Production'}</h1>
        <div className="underline"></div>
      </div>
    </section>
  );
};

export default Videoheader;
